import React, { useState } from "react";
import { useForm } from "react-hook-form";
import styles from "./NotificationModal.module.css";
import { Services } from "../../../Services";
import { toast } from "react-toastify";

export default function NotificationModal({ userId, open, onClose }) {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();
    const [Loading, setLoading] = useState(false);
    if (!open) return null;

    const onSubmit = (data) => {
        const token = {
            Authorization: `token ${sessionStorage.getItem("token")}`,
        };

        let body = JSON.stringify({ ...data, id: userId });
        Services?.sendNotificationSingle("POST", body, token)
            .then((res) => {
                if (res.Status == 1) {
                    reset();
                    onClose();
                    toast.success(`Notification Send Successful`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    toast.error(res?.Message, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch((err) => {
                setLoading(false);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    return (
        <div className={styles.backdrop}>
            <div className={styles.modal}>
                <header className={styles.header}>
                    <h2>Send Notification</h2>
                    <button onClick={onClose} className={styles.closeBtn}>
                        ✕
                    </button>
                </header>

                <form onSubmit={handleSubmit(onSubmit)} className={styles.body}>
                    <input
                        type="text"
                        placeholder="Enter notification title..."
                        className={styles.input}
                        {...register("title", {
                            required: "Title is required",
                        })}
                    />
                    {errors.title && (
                        <p className={styles.error}>{errors.title.message}</p>
                    )}

                    <textarea
                        placeholder="Enter your notification message..."
                        className={`${styles.textarea} ${styles.noResize}`}
                        {...register("body", {
                            required: "Message body is required",
                        })}
                    />
                    {errors.body && (
                        <p className={styles.error}>{errors.body.message}</p>
                    )}

                    <button
                        type="submit"
                        disabled={Loading}
                        className={styles.sendBtn}>
                        {!Loading ? "Send" : "...sending"}
                    </button>
                </form>
            </div>
        </div>
    );
}
